import React, { useEffect, useState } from "react";
import "./NavBar.css";
import companyLogo from "../../assets/company-logo.svg";
import smallCompanyLogo from "../../assets/small-company-logo.svg";

const NavBar = () => {
  const [visible, setVisible] = useState(false);
  const [showNav, setShowNav] = useState(true); // hide/show on scroll
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setVisible(true); // fade-in on mount

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNav(false); // scrolling down
      } else {
        setShowNav(true); // scrolling up
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (selector) => {
    const section = document.querySelector(selector);
    if (section) {
      const navbarHeight = 80;
      const yOffset = -navbarHeight;
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      setIsMenuOpen(false); // close menu after click
    }
  };

  return (
    <nav
      className={`navbar ${visible ? "navbar-enter-active" : "navbar-enter"} ${
        showNav ? "navbar-visible" : "navbar-hidden"
      }`}
    >
      <div className="titleNav">
        <img src={companyLogo} alt="Company Logo" className="companyLogo" />
        <img
          src={smallCompanyLogo}
          alt="Small Company Logo"
          className="smallCompanyLogo"
        />
      </div>

      {/* Menu items */}
      <div className="itemsNav">
        <ul className={isMenuOpen ? "active" : ""}>
          <li>
            <a
              href="https://ra-engineering-services.com"
              title="Go to Home Page"
            >
              Home
            </a>
          </li>
          <li onClick={() => scrollToSection(".about-section")}>
            <a>About</a>
          </li>
          <li onClick={() => scrollToSection(".services-section")}>
            <a>Services</a>
          </li>
          <li onClick={() => scrollToSection(".projects-section")}>
            <a>Projects</a>
          </li>
          <li
            className="contactUsDiv"
            onClick={() => scrollToSection(".contact-section")}
          >
            <a>Contact Us</a>
          </li>
        </ul>
      </div>

      {/* Burger Icon */}
      <div
        className={`burger ${isMenuOpen ? "open" : ""}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
      </div>
    </nav>
  );
};

export default NavBar;
